export default "/assets/444fae6cd1b7b453a0f14b63e58f6af5.png";